import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import addTag from "../../services/addTag";
import FixButton from "../../widgets/Button";
import Utils from "../../utils/utils";
import SelectInput from "../../widgets/SelectInput";
import getCategorieTag from "../../services/getCategorieTag";

export default class AddTag extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			tag: "",
			categoriaTag: null,
			categorieTagOptions: [],
		};

		this.pageTitle = "Aggiungi Tag";
	}

	async componentDidMount() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		const categorieTagOptions = await getCategorieTag(username, token);

		this.setState({ categorieTagOptions });
	}

	lockedSaveMateria = Utils.disallowConcurrency(this.save.bind(this));

	render() {
		return (
			<>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={this.pageTitle} />

					<SelectInput
						value={this.state.categoriaTag}
						name="Categoria tag"
						hidable={false}
						options={this.state.categorieTagOptions.map(item => ({
							value: item.id,
							label: item.nome,
						}))}
						onChange={option => this.setState({ categoriaTag: option })}
					/>

					<TextInput
						name={"Tag"}
						value={this.state.tag}
						onChange={text => {
							this.setState({ tag: text });
						}}
					/>

					<br />
					<FixButton title={"Salva"} callback={this.state.isLoading ? () => {} : this.lockedSaveMateria} />
				</LoadingOverlay>
			</>
		);
	}

	async save() {
		if (this.state.tag.trim() !== "") {
			this.setState({ isLoading: true });
			const cookies = new Cookies();
			const token = cookies.get("token", { path: "/" });
			const username = cookies.get("username", { path: "/" });

			if (this.state.categoriaTag === null || this.state.tag === "") {
				alert("Inserisci il nome del tag e seleziona una categoria prima di salvare.");
				return;
			}

			try {
				let ret = await addTag(username, token, this.state.tag, this.state.categoriaTag.value);

				if (ret.result === "ok") {
					this.setState({ isLoading: false });
					window.location.href = "/#/app/tag";
				} else {
					this.setState({ isLoading: false });
					alert("Si è verificato un errore durante la creazione del nuovo tag. Per favore, riprova.");
				}
			} catch (error) {
				this.setState({ isLoading: false });
				if (error === "Tag già esistente") {
					alert("Il tag inserito esiste già nella stessa categoria.");
				} else {
					alert("Si è verificato un errore: " + error);
				}
			}
		} else {
			alert("Inserisci il nome del tag prima di salvare.");
		}
	}
}
